import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

import {
  ALL_EVENT,
  customerConstants,
  PAGINATION,
} from "../../../../../constants";
import GenericTabs from "../../../../../shared/components/Tabs/GenericTabs";
import EventAccordion from "../../../../../shared/components/Accordion/EventAccordion";
import { shutterbDashboardActions } from "../../../../../redux/actions";
import ReelGallery from "./ReelGallery";
import ChangeRequestsReelEvents from "./Tabs/ChangeRequestsReelEvents";

const eventTabs = [
  {
    label: "pending",
    value: customerConstants.PENDING_EVENTS,
    className: "text",
  },
  {
    label: "completed",
    value: customerConstants.COMPLETED_EVENTS,
    className: "text",
  },
  {
    label: "change requests",
    value: customerConstants.CHANGE_REQUESTS,
    className: "text",
  },
];

const ReelEvents = (props) => {
  const [...reelEvents] = props.reelEvents;

  const [hasMore, setHasMore] = useState(false);
  const [hasMoreReels, setHasMoreReels] = useState(false);
  const [expandedAccordions, setExpandedAccordions] = useState({});
  const [pageNumber, setPageNumber] = useState(PAGINATION.PAGE_NUMBER);
  const [expandedSubAccordion, setExpandedSubAccordion] = useState(null);
  const [activeTab, setActiveTab] = useState(customerConstants.PENDING_EVENTS);

  const handleEvents = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    props.resetSbMyEvents();
    setPageNumber(1);
    setHasMore(false);
    setHasMoreReels(false);
    fetchEvents(1);
    // eslint-disable-next-line
  }, [activeTab]);

  const fetchEvents = async (_pageNumber) => {
    if (activeTab === customerConstants.CHANGE_REQUESTS) {
      await props.getChangeRequestReelEvents(
        props.sbUserId,
        _pageNumber,
        PAGINATION.PAGE_SIZE
      );
    } else {
      await props.getReelEvents(
        props.sbUserId,
        activeTab,
        _pageNumber,
        PAGINATION.PAGE_SIZE
      ); // assume page size 5
    }
  };

  useEffect(() => {
    if (props?.changeRequestReelEvents?.length) {
      const eventslength = props.changeRequestReelEvents.length;
      const totalGroupCount = props?.totalCount || 0;

      const shouldLoadMore = totalGroupCount > eventslength;
      setHasMore(shouldLoadMore);
      if (shouldLoadMore) {
        setPageNumber((prev) => prev + 1);
      }
    }
    // eslint-disable-next-line
  }, [props.changeRequestReelEvents]);

  useEffect(() => {
    if (props?.reelEvents?.length) {
      const reelEventslength = props.reelEvents?.length;
      const totalCount = props?.totalCount || 0;

      const shouldLoadMore = totalCount > reelEventslength;
      setHasMoreReels(shouldLoadMore);
      if (shouldLoadMore) {
        setPageNumber((prev) => prev + 1);
      }
    }
    // eslint-disable-next-line
  }, [props.reelEvents]);

  const handleTabChange = (tabValue) => {
    setActiveTab(tabValue);
    handleEvents(tabValue);
    closeAllAccordions();
    closeAllSubAccordions();
  };

  const handleSubAccordionChange = (panelId) => (event, isExpanded) => {
    setExpandedSubAccordion(isExpanded ? panelId : null);
  };

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [index]: isExpanded,
    }));
  };

  const closeAllSubAccordions = () => setExpandedSubAccordion(null);

  const closeAllAccordions = () => {
    setExpandedAccordions({});
  };

  return (
    <>
      <GenericTabs
        tabs={eventTabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === customerConstants.PENDING_EVENTS ||
      activeTab === customerConstants.COMPLETED_EVENTS ? (
        <div className="px-2">
          <InfiniteScroll
            dataLength={props.reelEvents.length}
            next={() => fetchEvents(pageNumber)}
            hasMore={hasMoreReels}
            loader={
              hasMoreReels ? (
                <p className="text-center">Loading more events...</p>
              ) : (
                <></>
              )
            }
            scrollThreshold="95%"
          >
            {reelEvents.length ? (
              reelEvents.map((event, index) => {
                const currentSubEvents = event.subEvents || [];
                return (
                  <EventAccordion
                    key={event.eventGroupId}
                    eventTitle={event.eventGroupName}
                    event={event}
                    isGroup={true}
                    classes="mui-event-accordion"
                    expanded={expandedAccordions[index] || false}
                    onChange={handleAccordionChange(index)}
                    isRecapEvents
                  >
                    {currentSubEvents.length > 0 ? (
                      <React.Fragment>
                        {currentSubEvents.map((subEvent, subIndex) => (
                          <EventAccordion
                            showEventDate
                            key={`${subEvent.id}-${subIndex}`}
                            event={subEvent}
                            isGroup={false}
                            showExpandedIcon
                            classes="mui-event-accordion mui-sub-event-accordion"
                            eventTitle={
                              subEvent.reelName
                                ? `${subEvent.reelName}`
                                : `${ALL_EVENT.name} Recap`
                            }
                            summaryLeadingChildren={
                              <span>{subIndex + 1}.</span>
                            }
                            expanded={
                              expandedSubAccordion === subEvent.orderItemId
                            }
                            onChange={handleSubAccordionChange(
                              subEvent.orderItemId
                            )}
                          >
                            {activeTab === customerConstants.PENDING_EVENTS ? (
                              <div>
                                <div className="row">
                                  <ReelGallery
                                    isCombinedEventsReel={
                                      subEvent.isCombinedEventsReel
                                    }
                                    eventId={subEvent?.id}
                                    eventName={event?.eventName}
                                    orderItemId={subEvent.orderItemId}
                                    eventGroupId={event.eventGroupId}
                                    isAllowDownload={subEvent?.isDownloadable}
                                    closeAllAccordions={closeAllAccordions}
                                    pageNumber={pageNumber}
                                    fetchEvents={fetchEvents}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                {subEvent.recaps?.length > 0 ? (
                                  subEvent.recaps.map((recap, index) => {
                                    const fullUrl = `${process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY}/${recap.url}`;
                                    const fileName = recap.url
                                      ?.split("/")
                                      .pop();

                                    return (
                                      <div key={index} className="mb-1">
                                        {index + 1}:{" "}
                                        <a
                                          href={fullUrl}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {fileName}
                                        </a>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <p className="text-muted text-center mb-0">
                                    No recaps available.
                                  </p>
                                )}
                              </>
                            )}
                          </EventAccordion>
                        ))}
                      </React.Fragment>
                    ) : (
                      <></>
                    )}
                  </EventAccordion>
                );
              })
            ) : (
              <p className="d-flex justify-content-center">
                you have no events at the moment.
              </p>
            )}
          </InfiniteScroll>
        </div>
      ) : (
        <div className="px-2">
          <InfiniteScroll
            dataLength={props.changeRequestReelEvents.length}
            next={() => fetchEvents(pageNumber)}
            hasMore={hasMore}
            loader={
              hasMore ? (
                <p className="text-center">Loading more events...</p>
              ) : (
                <></>
              )
            }
            scrollThreshold="95%"
          >
            {props.changeRequestReelEvents.length ? (
              props.changeRequestReelEvents.map((event, index) => {
                const currentSubEvents = event.subEvents || [];
                return (
                  <EventAccordion
                    key={event.eventGroupId}
                    eventTitle={event.eventGroupName}
                    event={event}
                    isGroup={true}
                    classes="mui-event-accordion"
                    expanded={expandedAccordions[index] || false}
                    onChange={handleAccordionChange(index)}
                    isRecapEvents
                  >
                    {currentSubEvents.length > 0 ? (
                      <React.Fragment>
                        {currentSubEvents.map((subEvent, subEventIndex) => {
                          return subEvent?.recaps.map((recap, recapIndex) => {
                            return (
                              <EventAccordion
                                key={`${subEvent.id}-${subEventIndex}`}
                                event={subEvent}
                                eventTitle={
                                  subEvent.reelName
                                    ? `${subEvent.reelName}`
                                    : `${ALL_EVENT.name} Recap`
                                }
                                isGroup={false}
                                showExpandedIcon
                                classes="mui-event-accordion mui-sub-event-accordion"
                                summaryLeadingChildren={
                                  <span>{subEventIndex + 1}.</span>
                                }
                                expanded={
                                  expandedSubAccordion === subEvent.orderItemId
                                }
                                onChange={handleSubAccordionChange(
                                  subEvent.orderItemId
                                )}
                              >
                                <ChangeRequestsReelEvents
                                  recap={recap}
                                  pageNumber={pageNumber}
                                  closeAllSubAccordions={closeAllSubAccordions}
                                />
                              </EventAccordion>
                            );
                          });
                        })}
                      </React.Fragment>
                    ) : (
                      <></>
                    )}
                  </EventAccordion>
                );
              })
            ) : (
              <p className="d-flex justify-content-center">
                you have no events at the moment.
              </p>
            )}
          </InfiniteScroll>
        </div>
      )}
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  totalCount: state.system.totalCount,
  sbUserId: state.shutterbAuthentication.sbUserId,
  userId: state.authentication.userId,
  reelEvents: state.shutterbDashboard.reelEvents,
  changeRequestReelEvents: state.shutterbDashboard.changeRequestReelEvents,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  resetSbMyEvents: () => dispatch(shutterbDashboardActions.resetSbMyEvents()),
  getReelEvents: (sbUserId, status, pageNumber, pageSize) =>
    dispatch(
      shutterbDashboardActions.getReelEvents(
        sbUserId,
        status,
        pageNumber,
        pageSize
      )
    ),
  getChangeRequestReelEvents: (sbUserId, pageNumber, pageSize) =>
    dispatch(
      shutterbDashboardActions.getChangeRequestReelEvents(
        sbUserId,
        pageNumber,
        pageSize
      )
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReelEvents));
